import React from 'react';
import cn from 'classnames';

import { ASSIGNMENT_STATUS_ICON_CLASSES, StatusIconVariant } from './constants';

export const AssignmentStatusIcon = (props: { variant: StatusIconVariant }) => (
  <i className={cn('ml-1', ASSIGNMENT_STATUS_ICON_CLASSES[props.variant])} />
);
